var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-qualify-step-need-and-application qualify-sidebar"},[_vm._v("\n    NEED AND APPLICATION CONTENT\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }